import React from 'react';
import './header.css';
import { HiArrowNarrowLeft, HiOutlineBell } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom'
import { useNavigation } from "../../hooks/navigationContext";

const icons = {
    arrowLeft: HiArrowNarrowLeft,
    bell: HiOutlineBell
}

const Header = ({ leftIcon, label, rightIcon, action }) => {

    const SelectedLeftIcon = icons[leftIcon];
    const SelectedRightIcon = icons[rightIcon];
    const navigate = useNavigate();
    const { setDirection } = useNavigation();

    

    return (
        <header>
            <div className="title-div">
                <div className='title-row'>

                    {leftIcon ? (
                        <button
                            className="header-icon-button"
                            onClick={() => {
                                setDirection(-1);
                                navigate(action);}}
                        >
                            <SelectedLeftIcon className="icon left" />
                        </button>
                    ) : (
                        <span>&nbsp;</span>
                    )}


                    <p className='app-title'>{label}</p>

                    {
                        rightIcon
                            ? <SelectedRightIcon className="icon right" />
                            : <span>&nbsp;</span>
                    }
                </div>
            </div>
        </header>
    );
};

export default Header;